import type { CrmSetupStepDefinition } from "../types";

export const CRM_SETUP_STEPS: CrmSetupStepDefinition[] = [
  {
    id: "introduction",
    label: "Apresentação",
    title: "Bem-vindo ao FluxZap",
    description:
      "Aqui você irá configurar automações e mensagens para cada etapa do atendimento. Nesta fase, vamos apenas preparar a estrutura do CRM.",
  },
  {
    id: "configuration",
    label: "Configuração",
    title: "Configuração inicial",
    description:
      "Vamos simular a configuração necessária para ativar as automações. No futuro, estes dados serão persistidos via API.",
  },
  {
    id: "sendTest",
    label: "Teste de envio",
    title: "Teste de envio",
    description:
      "Você poderá testar o envio de uma mensagem de exemplo. Por enquanto, o envio é apenas uma simulação.",
  },
  {
    id: "serviceContract",
    label: "Contrato de Serviço",
    title: "Contrato e franquia",
    description:
      "Aqui ficará a confirmação de termos e informações de franquia/contratação. Nesta etapa, ainda não há conteúdo real.",
  },
];
